import { Address } from '@frontend/api';
import { Box, Text, TextProps } from '@frontend/components';

import { formatAddressMultiline } from 'utils/formatters';

type AddressDisplayInformation = {
  businessName: string | null;
  attention: string | null;
  address: Address | null;
};

export const InlinedAddressDisplay = ({
  addressInformation,
  spanProps,
  ...restProps
}: TextProps & {
  addressInformation: AddressDisplayInformation | null;
  spanProps?: TextProps;
}) => {
  if (!addressInformation) {
    return <Text {...restProps}>None</Text>;
  }

  const { attention, businessName, address } = addressInformation;
  const addressLines = address ? formatAddressMultiline(address) : [];
  return (
    <Text {...restProps} noOfLines={1} whiteSpace="nowrap">
      <Text as="span" {...spanProps}>
        {businessName}
      </Text>{' '}
      {[attention, ...addressLines].filter(Boolean).join(' ')}
    </Text>
  );
};

export const AddressDisplay = ({
  addressInformation,
  ...restProps
}: TextProps & {
  addressInformation: AddressDisplayInformation | null;
}) => {
  if (!addressInformation) {
    return <Text {...restProps}>None</Text>;
  }

  const { attention, businessName, address } = addressInformation;
  const addressLines = address ? formatAddressMultiline(address) : [];
  return (
    <Box>
      <Text fontWeight="heavy">{businessName}</Text>
      <Text {...restProps}>{attention}</Text>
      {addressLines.map((line) => (
        <Text key={line} {...restProps}>
          {line}
        </Text>
      ))}
    </Box>
  );
};
